import { render } from "./SubmitDesign.vue?vue&type=template&id=820a45a8&scoped=true"
import script from "./SubmitDesign.vue?vue&type=script&lang=js"
export * from "./SubmitDesign.vue?vue&type=script&lang=js"

import "./SubmitDesign.vue?vue&type=style&index=0&id=820a45a8&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-820a45a8"]])

export default __exports__